import { AttributeType } from "@evergis/api";
import { LayerInfo } from "../../../interfaces/resourceInfo";
import { getLayerDefinition } from "./getLayerDefinition";

export function getAttributeType(layer: LayerInfo, attributeName: string): AttributeType {
  const { attributes } = getLayerDefinition(layer);
  const attribute = attributes[attributeName];

  return attribute ? attribute.type : AttributeType.Unknown;
}
